export const BaseUrl = "https://dev-api-spoton.webito.cloud/";
// export const BaseUrl = "http://192.168.1.87:8000/";
// export const BaseUrl = "http://192.168.1.137:8000/";

export const versionControl = "v1/";
export const ApiUrlCommon = "recruitmentnext/";


export const BUCKET_URL = "https://live-super-industry.s3.ap-south-1.amazonaws.com/";

export const api = {
    login: "admin/login",
    forgotPassword: "admin/forgotPassword",
    otpVerification: "admin/otpVerification",
    updatePassword: "admin/updatePassword",
    get_all_notifications: "admin/get_all_notifications",

    // File Upload API
    image: "upload/image",

    // Vendors API
    getVendors: "admin/getVendors",
    getVendorById: "admin/getVendorById",
    downloadVendor: "admin/downloadVendor",
    addVendor: "admin/addVendor",
    updateVendor: "admin/updateVendor",

    //  Inventory API
    getInventories: "admin/getInventories",
    addInventory: "admin/addInventory",
    updateInventory: "admin/updateInventory",
    getInventoryById: "admin/getInventoryById",
    getAllItemName: "admin/getAllItemName",
    getAllItemsByCategory: "admin/getAllItemsByCategory",
    createProduct: "admin/createProduct",
    getProductData: "admin/getProductData",
    deleteProduct: "admin/deleteProduct",
    getProductById:"admin/getProductById",

    // Master Inventory API
    getInventoryFields: "admin/getInventoryFields",
    addInventoryField: "admin/addInventoryField",
    updateInventoryField: "admin/updateInventoryField",
    getInventoryFieldById: "admin/getInventoryFieldById",
    deleteInventoryField: "admin/deleteInventoryField",
    // Purchase Order API
    downloadPO: "admin/downloadPO",
    downloadSheet: "admin/downloadSheet",
    addPurchaseOrder: "admin/addPurchaseOrder",
    getPurchaseOrders: "admin/getPurchaseOrders",
    getPODocumetsPoNumbers: "admin/getPODocumetsPoNumbers",
    getAdvanceLicensesForPODoc: "admin/getAdvanceLicensesForPODoc",
    getAdvancelicenseNumber:"admin/getAdvancelicenseNumber",
    getPurchaseOrderById: "admin/getPurchaseOrderById",
    deletePurchaseOrder: "admin/deletePurchaseOrder",
    updatePurchaseOrder: "admin/updatePurchaseOrder",
    downloadpurchaseOrderExcel: "admin/downloadpurchaseOrderExcel",




    //PO Documents
    addPODocument: "admin/addPODocument",
    updatePODocument: "admin/updatePODocument",
    getPODocuments: "admin/getPODocuments",
    deletePODocument: "admin/deletePODocument",
    getPODocumentById: "admin/getPODocumentById",
    changeStatusOfPurchaseOrder: "admin/changeStatusOfPurchaseOrder",
    getPoDcumentsByPoNumber: "admin/getPoDcumentsByPoNumber",

    //Purchase Entery APIs
    getAllPOList: "admin/getAllPOList",
    getPoNumbersByVendor: "admin/getPoNumbersByVendor",
    addPurchaseEntry: "admin/addPurchaseEntry",
    getPurchaseEntrys: "admin/getPurchaseEntrys",
    getPurchaseEntryById: "admin/getPurchaseEntryById",
    downloadGrn: "admin/downloadGrn",
    deletePurchaseEntry: "admin/deletePurchaseEntry",
    getRemainingQuantity: "admin/getRemainingQuantity",
    updateRemainingQuantityByPONumber: "admin/updateRemainingQuantityByPONumber",
    updatePurchaseEntry: "admin/updatePurchaseEntry",
    getPurchaseEntryItems:"admin/getPurchaseEntryItems",
    getPurchaseEntryNumber:"admin/getPurchaseEntryNumber",

    //Lot Number APIs
    addLotNumber: "admin/addLotNumber",
    getLotNumbers: "admin/getLotNumbers",
    getLotNumberById: "admin/getLotNumberById",
    deleteLotNumber: "admin/deleteLotNumber",
    updateLotNumber: "admin/updateLotNumber",
    getPerticularLotNumbers: "admin/getPerticularLotNumbers",
    getPOItem: "admin/getPOItem",
    getGrnAndLotNumberByPoNumber: "admin/getGrnAndLotNumberByPoNumber",

    //Production APIs
    getProductionLotNumber: "admin/getProductionLotNumber",
    getItemForUpdateProduction: "admin/getItemForUpdateProduction",
    getItemByLotNumber: "admin/getItemByLotNumber",
    getAllProductionList: "admin/getAllProductionList",
    getPerticularProductionAllItem: "admin/getPerticularProductionAllItem",
    moveItemToProduction: "admin/moveItemToProduction",
    deleteProduction: "admin/deleteProduction",
    updateProduction: "admin/updateProduction",

    //Processing APIs
    getProcessItems: "admin/getProcessItems",
    getLotNumbersByCategory: "admin/getLotNumbersByCategory",
    getItemsByCategory: "admin/getItemsByCategory",
    getProcessItemById: "admin/getProcessItemById",
    updateProcessItem: "admin/updateProcessItem",
    addProcessItem: "admin/addProcessItem",

    //Processing APIs
    addDocument: "admin/addDocument",
    updateDocument: "admin/updateDocument",
    getDocuments: "admin/getDocuments",
    getDocumentsByType: "admin/getDocumentsByType",
    getTotalProduction: "admin/getTotalProduction",
    getDocumentById: "admin/getDocumentById",
    getPoDocumentsByAdvanceLicense: "admin/getPoDocumentsByAdvanceLicense",
    deleteDocument: "admin/deleteDocument",
    downloadSheet: "admin/downloadSheet",

    //Invoice APIs
    getInvoiceItemList: "admin/getInvoiceItemList",
    addInvoice: "admin/addInvoice",
    updateInvoice: "admin/updateInvoice",
    getInvoices: "admin/getInvoices",
    getInvoiceById: "admin/getInvoiceById",
    getInvoiceItemById :"admin/getInvoiceItemById",

    //Customer APIs
    getAllStateAndCity: "admin/getAllStateAndCity",
    updateCustomer: "admin/updateCustomer",
    addCustomer: "admin/addCustomer",
    getCustomers: "admin/getCustomers",
    getCustomerById: "admin/getCustomerById",
    deleteCustomer: "admin/deleteCustomer",



    // Role APIs
    getRoleManagement: "admin/getRoleManagement",
    addRoleManagement: "admin/addRoleManagement",
    updateRoleManagement: "admin/updateRoleManagement",
    getRoleManagementById: "admin/getRoleManagementById",

    getPermission: "admin/getPermissionByEmail",

    //dashboard
    VandorOverview: "admin/getVandorOverview",
    getPoStatus :'admin/getPoStatus',
    getPoTableStatus : 'admin/getPoList',

    getExpense : 'admin/getExpense',
    getSalesAndPurchase : 'admin/getPurchaseAndSales',
    getAllRevenue : 'admin/getAllRevenue'

};

export const LOGIN_TOKEN = "LOGIN_TOKEN";
export const REFRESH_TOKEN = "REFRESH_TOKEN";
